import { render, staticRenderFns } from "./UgcProfile.vue?vue&type=template&id=5ec532ad&"
import script from "./UgcProfile.vue?vue&type=script&lang=ts&"
export * from "./UgcProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports